import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { addData, getList } from "../../helpers/fackBackend_Helper";

function* getAllRechargePriceMappingDataResponse({ payload: { data } }) {
  try {
    // debugger;
    const response = yield call(addData, "/getrechargeMapping", data);
    if (response.Status) {
      yield put(actions.getAllRechargePriceMappingDataSuccess(response.Data));
    } else {
      yield put(actions.getAllRechargePriceMappingDataFailed(response.Message));
    }
  } catch (error) {
    yield put(actions.getAllRechargePriceMappingDataFailed(error.Message));
  }
}

function* getRechargePlanWiseMappingResponse({ payload: { data } }) {
  try {
    // debugger;
    const response = yield call(addData, "/getAllNetworkRechargePlans", data);
    if (response.Status) {
      yield put(actions.getRechargePlanWiseMappingSuccess(response.Data));
    } else {
      yield put(actions.getRechargePlanWiseMappingFailed(response.Message));
    }
  } catch (error) {
    yield put(actions.getRechargePlanWiseMappingFailed(error.Message));
  }
}

function* updateRechargePriceMappingDataResponse({ data, searchData }) {
  try {
    const response = yield call(addData, "/rechargeMapping", data);
    if (response.Status) {
      const responseList = yield call(
        addData,
        "/getrechargeMapping",
        searchData,
      );
      if (responseList.Status) {
        yield put(
          actions.updateRechargePriceMappingDataSuccess(
            response.Message,
            responseList.Data,
          ),
        );
      } else {
        yield put(actions.getRechargeWiseMappingFailed(response.Message));
      }
    } else {
      yield put(actions.getRechargeWiseMappingFailed(response.Message));
    }
  } catch (error) {
    yield put(actions.updateRechargePriceMappingDataFailed(error.Message));
  }
}
export default function* rootSaga() {
  yield all([
    takeEvery(
      actions.GET_ALL_RECHARGE_PRICE_MAPPING_DATA,
      getAllRechargePriceMappingDataResponse,
    ),
  ]);
  yield all([
    takeEvery(
      actions.UPDATE_RECHARGE_PRICE_MAPPING_DATA,
      updateRechargePriceMappingDataResponse,
    ),
  ]);
  yield all([
    takeEvery(
      actions.GET_RECHARGE_PLAN_WISE_MAPPING,
      getRechargePlanWiseMappingResponse,
    ),
  ]);
}
